// Navigation
const NavigationBar = () => import('@/components/NavigationBar')

// Home View
const HomeView = () => import('@/views/buyer/HomeView')

// Promotions View
const PromotionsView = () => import('@/views/buyer/PromotionsView')

// Orders Views
const MyOrdersView = () => import('@/views/buyer/MyOrdersView')
const ReceiptView = () => import('@/views/buyer/order/ReceiptView')
const OrderIssueView = () => import('@/views/buyer/order/OrderIssueView')

// Chef Views
const ChefView = () => import('@/views/buyer/ChefView')
const ReportChefView = () => import('@/views/buyer/chef/ReportChefView')

// Checkout View
const CheckoutView = () => import('@/views/buyer/CheckoutView')

// Promotions View
const PaymentView = () => import('@/views/buyer/PaymentView')
const AddPaymentMethodView = () => import('@/views/buyer/AddPaymentMethodView')

import getUsersSlugs from '../utils/getUsersSlugs'

const buyerRoutes = [
  {
    path: '/',
    name: 'BuyerHomeView',
    component: HomeView,
    meta: {
      sitemap: {
        priority: 1,
        changefreq: 'daily'
      }
    }
  },
  {
    path: '/orders',
    name: 'MyOrdersView',
    component: MyOrdersView,
    components: {
      default: MyOrdersView,
      navigation: NavigationBar
    },
    meta: {
      requiresAuth: true,
      transitionName: 'slide-up',
      sitemap: { ignoreRoute: true }
    }
  },
  {
    path: '/orders/:id/receipt',
    name: 'ReceiptView',
    component: ReceiptView,
    props: true,
    meta: {
      requiresAuth: true,
      transitionName: 'slide-up',
      sitemap: { ignoreRoute: true }
    }
  },
  {
    path: '/orders/:id/issue',
    name: 'OrderIssueView',
    component: OrderIssueView,
    props: true,
    meta: {
      requiresAuth: true,
      transitionName: 'slide-up',
      sitemap: { ignoreRoute: true }
    }
  },
  {
    path: '/promotions',
    name: 'PromotionsView',
    components: {
      default: PromotionsView,
      navigation: NavigationBar
    },
    meta: { requiresAuth: true, sitemap: { ignoreRoute: true } }
  },
  {
    path: '/cook/:slug',
    name: 'ChefView',
    component: ChefView,
    props: true,
    meta: {
      transitionName: 'slide-up',
      sitemap: { slugs: getUsersSlugs }
    }
  },
  {
    path: '/cook/:slug/report',
    name: 'ReportChefView',
    component: ReportChefView,
    meta: {
      requiresAuth: true,
      transitionName: 'slide-up',
      sitemap: { ignoreRoute: true }
    }
  },
  {
    path: '/checkout',
    name: 'CheckoutView',
    component: CheckoutView,
    props: true,
    meta: { requiresAuth: true, sitemap: { ignoreRoute: true } }
  },
  {
    path: '/payment',
    name: 'PaymentView',
    components: {
      default: PaymentView,
      navigation: NavigationBar
    },
    props: {
      navigation: ({ params }) => params.navigation
    },
    meta: {
      requiresAuth: true,
      sitemap: { ignoreRoute: true }
    }
  },
  {
    path: '/payment/add',
    name: 'AddPaymentMethodView',
    component: AddPaymentMethodView,
    props: true,
    meta: { requiresAuth: true, sitemap: { ignoreRoute: true } }
  }
]

export default buyerRoutes
